import React, { useState } from "react";
import { Button, Flex, Input } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";

import { POINTS_ADMIN } from "../../../config/lang";
import { translate } from "../../../util/util";

// An editor for a JSON object field: rows of { label -> value } the user can add and remove.
// The stored value is a plain object { key: value }.
const toRows = v =>
  v && typeof v === "object" && !Array.isArray(v) ? Object.entries(v).map(([key, value]) => ({ key, value: value == null ? "" : String(value) })) : [];

const toObject = rows =>
  rows.reduce((o, r) => {
    const k = r.key.trim();
    if (k) o[k] = r.value;
    return o;
  }, {});

export default function KeyValueField({ field, value, onChange, lang }) {
  const [rows, setRows] = useState(() => toRows(value));
  const t = key => translate(POINTS_ADMIN, key, lang);

  const sync = next => {
    setRows(next);
    onChange(field.name, toObject(next));
  };
  const update = (i, key, val) => sync(rows.map((r, idx) => (idx === i ? { ...r, [key]: val } : r)));
  /* A blank row carries no key, so it is not in the stored object yet — adding one is local
     state, not a change to the record. */
  const add = () => setRows([...rows, { key: "", value: "" }]);
  const remove = i => sync(rows.filter((_, idx) => idx !== i));

  return (
    <Flex vertical gap="small" align="flex-start">
      {rows.map((row, i) => (
        <Flex key={i} gap="small" style={{ width: "100%" }}>
          <Input placeholder={t("kv_key")} aria-label={t("kv_key")} value={row.key} onChange={e => update(i, "key", e.target.value)} />
          <Input placeholder={t("kv_value")} aria-label={t("kv_value")} value={row.value} onChange={e => update(i, "value", e.target.value)} />
          <Button type="text" icon={<DeleteOutlined />} aria-label={t("delete_btn")} onClick={() => remove(i)} />
        </Flex>
      ))}
      <Button size="small" icon={<PlusOutlined />} onClick={add}>
        {t("kv_add")}
      </Button>
    </Flex>
  );
}
